/**
 * Escape user-controlled strings before inserting into HTML (e.g. Leaflet popups).
 */
export function escapeHtml(value) {
  if (value == null) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Truncate for previews; escapes HTML after truncating plain text.
 */
export function escapeAndTruncate(value, maxLen = 100) {
  const raw = value == null ? '' : String(value);
  const truncated =
    raw.length > maxLen ? `${raw.substring(0, maxLen)}...` : raw;
  return escapeHtml(truncated);
}
